export default `{
  "reject_requests": ["png", "jpg"]
}`